module.exports = __webpack_public_path__ + "img/6531.2876a76a.jpg";